export default "__VITE_ASSET__DOVlGz$I__"